/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreditLineBookingResponse,
  DailySpendHistoryDto,
  GetMonthlySpendHistoryForUserParams,
  GetMonthlySpendHistoryParams,
  MonthlySpendHistoryDto,
  OrganisationCreditBalanceResponse,
  OrganisationDebitBalanceResponse,
  OrganisationLimitsResponse,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiBalanceController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-balance-controller
   * @name GetMonthlySpendHistoryForUser
   * @request GET:/api/v1/balance/spend-history/user/monthly
   */
  getMonthlySpendHistoryForUser = (
    query: GetMonthlySpendHistoryForUserParams,
    params: RequestParams = {},
  ) =>
    this.http.request<MonthlySpendHistoryDto[], any>({
      path: `/v1/balance/spend-history/user/monthly`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMonthlySpendHistoryForUserPath = '/v1/balance/spend-history/user/monthly'
  static getMonthlySpendHistoryForUserMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name GetMonthlySpendHistory
   * @request GET:/api/v1/balance/spend-history/monthly
   */
  getMonthlySpendHistory = (query: GetMonthlySpendHistoryParams, params: RequestParams = {}) =>
    this.http.request<MonthlySpendHistoryDto[], any>({
      path: `/v1/balance/spend-history/monthly`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMonthlySpendHistoryPath = '/v1/balance/spend-history/monthly'
  static getMonthlySpendHistoryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name GetDailySpendHistory
   * @request GET:/api/v1/balance/spend-history/daily
   */
  getDailySpendHistory = (params: RequestParams = {}) =>
    this.http.request<DailySpendHistoryDto[], any>({
      path: `/v1/balance/spend-history/daily`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDailySpendHistoryPath = '/v1/balance/spend-history/daily'
  static getDailySpendHistoryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindCreditBalanceDeprecated
   * @request GET:/api/v1/balance/organisation
   * @deprecated
   */
  findCreditBalanceDeprecated = (params: RequestParams = {}) =>
    this.http.request<OrganisationCreditBalanceResponse, any>({
      path: `/v1/balance/organisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCreditBalanceDeprecatedPath = '/v1/balance/organisation'
  static findCreditBalanceDeprecatedMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindCreditBalanceByOrgIdDeprecated
   * @request GET:/api/v1/balance/organisation/{id}
   * @deprecated
   */
  findCreditBalanceByOrgIdDeprecated = (id: string, params: RequestParams = {}) =>
    this.http.request<OrganisationCreditBalanceResponse, any>({
      path: `/v1/balance/organisation/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCreditBalanceByOrgIdDeprecatedPath = '/v1/balance/organisation/${id}'
  static findCreditBalanceByOrgIdDeprecatedMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindDebitBalance
   * @request GET:/api/v1/balance/organisation/debit
   */
  findDebitBalance = (params: RequestParams = {}) =>
    this.http.request<OrganisationDebitBalanceResponse, any>({
      path: `/v1/balance/organisation/debit`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findDebitBalancePath = '/v1/balance/organisation/debit'
  static findDebitBalanceMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindDebitBalanceByOrgId
   * @request GET:/api/v1/balance/organisation/debit/{id}
   */
  findDebitBalanceByOrgId = (id: string, params: RequestParams = {}) =>
    this.http.request<OrganisationDebitBalanceResponse, any>({
      path: `/v1/balance/organisation/debit/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findDebitBalanceByOrgIdPath = '/v1/balance/organisation/debit/${id}'
  static findDebitBalanceByOrgIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindCreditBalance
   * @request GET:/api/v1/balance/organisation/credit
   */
  findCreditBalance = (params: RequestParams = {}) =>
    this.http.request<OrganisationCreditBalanceResponse, any>({
      path: `/v1/balance/organisation/credit`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCreditBalancePath = '/v1/balance/organisation/credit'
  static findCreditBalanceMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindCreditBalanceByOrgId
   * @request GET:/api/v1/balance/organisation/credit/{id}
   */
  findCreditBalanceByOrgId = (id: string, params: RequestParams = {}) =>
    this.http.request<OrganisationCreditBalanceResponse, any>({
      path: `/v1/balance/organisation/credit/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findCreditBalanceByOrgIdPath = '/v1/balance/organisation/credit/${id}'
  static findCreditBalanceByOrgIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindLimits
   * @request GET:/api/v1/balance/limits
   */
  findLimits = (params: RequestParams = {}) =>
    this.http.request<OrganisationLimitsResponse, any>({
      path: `/v1/balance/limits`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findLimitsPath = '/v1/balance/limits'
  static findLimitsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name GetMonthlyCardSpendHistory
   * @request GET:/api/v1/balance/card-spend-history/monthly
   */
  getMonthlyCardSpendHistory = (params: RequestParams = {}) =>
    this.http.request<MonthlySpendHistoryDto[], any>({
      path: `/v1/balance/card-spend-history/monthly`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMonthlyCardSpendHistoryPath = '/v1/balance/card-spend-history/monthly'
  static getMonthlyCardSpendHistoryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-balance-controller
   * @name FindBooking
   * @request GET:/api/v1/balance/booking
   */
  findBooking = (params: RequestParams = {}) =>
    this.http.request<CreditLineBookingResponse, any>({
      path: `/v1/balance/booking`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findBookingPath = '/v1/balance/booking'
  static findBookingMethod = 'GET'
}
